module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('product-tree-picker', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.selected && _vm.selected.length > 0) ? _c('pre', {
    staticClass: "caption grey lighten-4 pa-3",
    domProps: {
      "textContent": _vm._s(_vm.selected.join(','))
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "width": "600"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      Upgrade your account\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-5 my-3"
  }, [_c('v-card-title', {
    staticClass: "title blue-grey darken-4 white--text"
  }, [_vm._v("\n              STARTER\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("R300")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('ul', [_c('li', [_vm._v("Best effort support")])]), _vm._v(" "), _c('ul', [_c('li', [_c('s', [_vm._v("SMS Notifications")])])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": ""
    }
  }, [_vm._v("Select Starter")])], 1), _vm._v(" "), _c('v-card-text', [_c('small', [_vm._v("* Not eligible for promotions, discounts and special offers")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-20 pb-3",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title black white--text"
  }, [_vm._v("\n              PRO\n              "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "success"
    }
  }, [_vm._v("R500")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-3"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('div', [_c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Priority support")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" SMS notifications")], 1)])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": ""
    }
  }, [_vm._v("Select Pro")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "my-3 blue-grey--text"
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Cancel anytime")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Change your package whenever you like")], 1)])], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Appointment ID"
    },
    model: {
      value: (_vm.appointmentId),
      callback: function($$v) {
        _vm.appointmentId = $$v
      },
      expression: "appointmentId"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.appt.loading
    },
    on: {
      "click": function($event) {
        return _vm.getAppointment(_vm.appointmentId)
      }
    }
  }, [_vm._v("fetch")]), _vm._v(" "), _c('v-system-bar', {
    staticClass: "overline",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    Your appointment\n  ")]), _vm._v(" "), (_vm.appointmentDetail) ? _c('small-appointment-card', {
    attrs: {
      "fetch": ""
    },
    model: {
      value: (_vm.appointmentDetail),
      callback: function($$v) {
        _vm.appointmentDetail = $$v
      },
      expression: "appointmentDetail"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("fetchAppointments", [181139, 169790, 181766])
      }
    }
  }, [_vm._v("\n      Fetch mutation")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getAppointmentsInRange
    }
  }, [_vm._v("Fetch appts")]), _vm._v("\n    Permission: " + _vm._s(_vm.permissionResult) + " |\n    "), _c('v-text-field', {
    attrs: {
      "label": "action name"
    },
    model: {
      value: (_vm.actionName),
      callback: function($$v) {
        _vm.actionName = $$v
      },
      expression: "actionName"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.permissionResult = _vm.hasPermission("foo", 887)
      }
    }
  }, [_vm._v("Check")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getClientInfo
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.clientInfo))])], 1), _vm._v(" "), _c('become')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b78caa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TestPage.vue
// module id = 1657
// module chunks = 1